import { render, staticRenderFns } from "./profile-tab.vue?vue&type=template&id=3dd3cfb8&scoped=true"
import script from "./profile-tab.vue?vue&type=script&lang=js"
export * from "./profile-tab.vue?vue&type=script&lang=js"
import style0 from "./profile-tab.vue?vue&type=style&index=0&id=3dd3cfb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd3cfb8",
  null
  
)

export default component.exports